const getPageAndPosition = (
  page: number,
  position: number,
  location?: string,
) => {
  if (location && ['ADD_TO_CART_PAGE', 'CART_PAGE'].includes(location)) {
    return position;
  }

  const positionString: string = `${position}`.padStart(2, '0');
  return Number(`${page === 0 ? 1 : page}${positionString}`);
};

export default getPageAndPosition;
